const KEYBOARD_HEIGHT_TOLERANCE = 100;

const isCustomPropsSupport = !!document.documentElement.style.setProperty;

const vhDiv = document.createElement('div');
Object.assign(vhDiv.style, {
  position: 'absolute',
  left: '-1000px',
  height: '100vh',
});
document.body.appendChild(vhDiv);

let windowSize = null;
let checkPending = false;

const updateStepHeight = () => {
  windowSize = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  const vh = getOriginalVh();
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const getOriginalVh = () => {
  const height = getComputedStyle(vhDiv).getPropertyValue('height');
  return (parseInt(height, 10) || window.innerHeight) * 0.01;
};

const checkWindowSize = () => {
  if (checkPending) return;
  checkPending = true;

  requestAnimationFrame(() => {
    checkPending = false;

    // initial value
    if (windowSize === null) {
      updateStepHeight();
      return;
    }

    const isWidthChange = window.innerWidth !== windowSize.width;
    const isHardlyKeyboard = windowSize.height - window.innerHeight < KEYBOARD_HEIGHT_TOLERANCE;

    // skip height update if keyboard was opened
    const isResize = isWidthChange || isHardlyKeyboard;
    if (isResize) updateStepHeight();
  });
};

if (isCustomPropsSupport) {
  window.addEventListener('resize', checkWindowSize);
  checkWindowSize();
}
